import React from "react"

export const IconBackground = ({ children, bg }: { children: React.ReactNode; bg?: string }) => (
    <div className={`flex items-center justify-center ${bg ?? "bg-gray-200"} h-34 w-34 rounded`}>{children}</div>
)
